import { Component } from '@angular/core';
import { StoryAbstract } from '../shared/story-abstract';
import { get } from 'lodash-es';

@Component({
  selector: 'pixie-destination',
  templateUrl: '../shared/story.component.html',
  styleUrls: ['./destination.component.scss']
})
export class DestinationComponent extends StoryAbstract {

  getTemplateBlockGroups(storyData) {
    // let templateBlockGroups = [];
    const templateBlockGroups = [
      // BLOCK GROUP 1
      {
          'classes': 'full-desktop',
          'anchorName': 'destination-hero-block-group-1-anchor',
          'blocks': [
              // heroCard
              {
                  'analyticsTrackSeen' : this.createAnalyticsTrackSeen(storyData, 1,
                      storyData.descriptions.heroCard.analyticsLinkId),
                  'classes': 'full-desktop hero-card ' +
                      this.getCSSSectionClasses(
                          get(storyData, 'descriptions.heroCard', false)
                      ),
                  'items': storyData.descriptions.heroCard.media.cinemagraphMedia1 ? [
                          this.getPixiePlayerTemplate(storyData.descriptions.heroCard)
                      ] : [
                      {
                          'type': 'link',
                          'classes': '',
                          'href': storyData.descriptions.heroCard.link,
                          'target': '_self',
                          'analyticsLinkId': this.getStoryAnalyticslinkId(storyData,
                              1,
                              storyData.descriptions.heroCard.analyticsLinkId),
                          itemsWrapped: {
                            background: [
                                this.getImageTemplate(
                                    storyData.descriptions.heroCard.media.backgroundDesktop,
                                    'background zoom-on-hover ' +
                                        'hidden-xs visible-sm visible-md visible-lg'
                                ),
                                this.getImageTemplate(
                                    storyData.descriptions.heroCard.media.backgroundMobile,
                                    'background visible-xs hidden-sm hidden-md hidden-lg'
                                )
                            ],
                            foreground: [
                                this.getTitleTemplate(storyData.descriptions.heroCard)
                            ]
                          }
                      }
                  ]
              }
          ]
      },
      // BLOCK GROUP 2
      {
          'classes': 'full-desktop',
          'anchorName': 'destination-hero-block-group-2-anchor',
          'blocks': [
              // squareCard1
              {
                  'analyticsTrackSeen' : this.createAnalyticsTrackSeen(storyData, 2,
                      storyData.descriptions.squareCard1.analyticsLinkId),
                  'classes': 'one-third-desktop story-block-1 story-block-row ' +
                      this.getCSSSectionClasses(
                          get(storyData, 'descriptions.squareCard1', false)
                      ),
                  'items': storyData.descriptions.squareCard1.media.cinemagraphMedia1 ? [
                          this.getPixiePlayerTemplate(storyData.descriptions.squareCard1)
                      ] : [
                      {
                          'type': 'link',
                          'classes': '',
                          'href': storyData.descriptions.squareCard1.link,
                          'target': '_self',
                          'analyticsLinkId': this.getStoryAnalyticslinkId(storyData,
                              2,
                              storyData.descriptions.squareCard1.analyticsLinkId),
                          itemsWrapped: {
                              background: [
                                this.getImageTemplate(
                                    storyData.descriptions.squareCard1.media.backgroundDesktop,
                                    'background hidden-xs visible-sm hidden-md hidden-lg'
                                ),
                                this.getImageTemplate(
                                    storyData.descriptions.squareCard1.media.backgroundMobile,
                                    'background zoom-on-hover ' +
                                        'visible-xs hidden-sm visible-md visible-lg'
                                )
                              ],
                              foreground: [
                                  this.getTitleTemplate(storyData.descriptions.squareCard1)
                              ]
                          }
                      }
                  ]
              },
              // squareCard2
              {
                  'analyticsTrackSeen' : this.createAnalyticsTrackSeen(storyData, 3,
                      storyData.descriptions.squareCard2.analyticsLinkId),
                  'classes': 'one-third-desktop story-block-2 story-block-row ' +
                      this.getCSSSectionClasses(
                          get(storyData, 'descriptions.squareCard2', false)
                      ),
                  'items': storyData.descriptions.squareCard2.media.cinemagraphMedia1 ? [
                          this.getPixiePlayerTemplate(storyData.descriptions.squareCard2)
                      ] : [
                      {
                          'type': 'link',
                          'classes': '',
                          'href': storyData.descriptions.squareCard2.link,
                          'target': '_self',
                          'analyticsLinkId': this.getStoryAnalyticslinkId(storyData,
                              3,
                              storyData.descriptions.squareCard2.analyticsLinkId),
                          itemsWrapped: {
                              background: [
                                this.getImageTemplate(
                                    storyData.descriptions.squareCard2.media.backgroundDesktop,
                                    'background hidden-xs visible-sm hidden-md hidden-lg'
                                ),
                                this.getImageTemplate(
                                    storyData.descriptions.squareCard2.media.backgroundMobile,
                                    'background zoom-on-hover ' +
                                        'visible-xs hidden-sm visible-md visible-lg'
                                )
                              ],
                              foreground: [
                                this.getTitleTemplate(storyData.descriptions.squareCard2)
                              ]
                          }
                      }
                  ]
              },
              // squareCard3
              {
                  'analyticsTrackSeen' : this.createAnalyticsTrackSeen(storyData, 4,
                      storyData.descriptions.squareCard3.analyticsLinkId),
                  'classes': 'one-third-desktop story-block-3 story-block-row ' +
                      this.getCSSSectionClasses(
                          get(storyData, 'descriptions.squareCard3', false)
                      ),
                  'items': storyData.descriptions.squareCard3.media.cinemagraphMedia1 ? [
                          this.getPixiePlayerTemplate(storyData.descriptions.squareCard3)
                      ] : [
                      {
                          'type': 'link',
                          'classes': '',
                          'href': storyData.descriptions.squareCard3.link,
                          'target': '_self',
                          'analyticsLinkId': this.getStoryAnalyticslinkId(storyData,
                              4,
                              storyData.descriptions.squareCard3.analyticsLinkId),
                          itemsWrapped: {
                              background: [
                                  this.getImageTemplate(
                                      storyData.descriptions.squareCard3.media.backgroundDesktop,
                                      'background hidden-xs visible-sm hidden-md hidden-lg'
                                  ),
                                  this.getImageTemplate(
                                      storyData.descriptions.squareCard3.media.backgroundMobile,
                                      'background zoom-on-hover ' +
                                          'visible-xs hidden-sm visible-md visible-lg'
                                  )
                              ],
                              foreground: [
                                  this.getTitleTemplate(storyData.descriptions.squareCard3)
                              ]
                          }
                      }
                  ]
              }
          ]
      }
  ];

    return templateBlockGroups;
  }

}
